import { Col, Row } from 'react-bootstrap'
import illustration30 from '../../../assets/img/ecommerce/banners/Illustration.webp'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronRight } from '@fortawesome/free-solid-svg-icons'

const EcomRegisterProvider = () => {
  return (
    <Row className="flex-center mb-15 mt-11 gy-6">
      <Col xs="auto">
        <img src={illustration30} alt="" className="d-dark-none" width={400} />
        <img src={illustration30} alt="" className="d-light-none" width={305} />
      </Col>
      <Col xs="auto">
        <div className="text-center text-lg-start">
          <h3 className="text-1000 fw-medium mb-2">
            Te gustaría recibir más solicitudes de servicios?
          </h3>
          <h1 className="display-3 fw-semi-bold mb-4">
            Registrate como <span className="text-primary fw-bolder">Proveedor</span>
          </h1>
          <Link to="https://forms.gle/PJ2rHLkqBPzWYS13A" rel="noopener noreferrer" target="_blank" className="btn btn-lg btn-primary px-7">
            Quiero saber más
            <FontAwesomeIcon icon={faChevronRight} className="ms-2 fs-9" />
          </Link>
        </div>
      </Col>
    </Row>
  )
}

export default EcomRegisterProvider
